import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form, Table, Pagination } from "react-bootstrap";
import {
  DeleteAppSetup,
  GetAllAppSetup,
  sendAppSetup,
} from "../../../features/admin/app_setup/Slice";
import { useDispatch, useSelector } from "react-redux";
import CDeleteModel from "../../common_components/common-modal/delete/CDeleteModel";
import { useNavigate } from "react-router-dom";
import Success_Modal from "../../common_components/common-modal/success_modal/Success_Modal";
import Reject_Modal from "../../common_components/common-modal/reject_modal/Reject_Modal";

const Notification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [rdelete, setRDelete] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [deleteType, setDeleteType] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const Notification = useSelector((state) => state.appsetup.app_setup);

  console.log(Notification, "NotificationNotification");

  const rows = Notification?.data || [];

  const currentPage = Number(Notification?.current_page || 1);
  const perPage = Number(Notification?.per_page || 10);
  const total = Number(Notification?.total || 0);

  const fetchNotifications = async (page = 1) => {
    await dispatch(
      GetAllAppSetup({
        name: name || "",
        email: email || "",
        page,
        per_page: 10,
      }),
    );
  };

  useEffect(() => {
    fetchNotifications(1);
  }, [name, email]);

  const handlePageChange = (page) => {
    if (page < 1) return;

    const lastPage = Math.ceil(total / perPage);

    if (lastPage > 0 && page > lastPage) {
      return;
    }

    fetchNotifications(page);

    setSelectedRows([]);
    setSelectAll(false);
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;

    setSelectAll(checked);

    if (checked) {
      setSelectedRows(rows.map((item) => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        setSelectAll(false);

        return prev.filter((item) => item !== id);
      }

      const updatedRows = [...prev, id];

      if (rows.length > 0 && updatedRows.length === rows.length) {
        setSelectAll(true);
      }

      return updatedRows;
    });
  };

  const handleDeleteClick = (row) => {
    setDeleteRow(row);
    setDeleteType("single");
    setRDelete(true);
  };

  const handleDelete = async () => {
    if (!deleteRow?.id) {
      return;
    }

    try {
      await dispatch(DeleteAppSetup(deleteRow.id)).unwrap();

      setDeleteRow(null);
      setDeleteType(null);
      setRDelete(false);

      await fetchNotifications(currentPage);
    } catch (error) {
      console.error("Delete notification error:", error);
    }
  };

  const handleDeleteSelectedClick = () => {
    if (selectedRows.length === 0) {
      return;
    }

    setDeleteType("multiple");
    setRDelete(true);
  };

  const handleDeleteSelected = async () => {
    if (selectedRows.length === 0) {
      return;
    }

    try {
      await dispatch(DeleteAppSetup(selectedRows)).unwrap();

      setSelectedRows([]);
      setSelectAll(false);
      setDeleteType(null);
      setRDelete(false);

      await fetchNotifications(1);
    } catch (error) {
      console.error("Delete selected notifications error:", error);
    }
  };

  const handleDeleteAllClick = () => {
    if (rows.length === 0) {
      return;
    }

    setDeleteType("all");
    setRDelete(true);
  };

  const handleDeleteAll = async () => {
    if (rows.length === 0) {
      return;
    }

    const allIds = rows.map((row) => row.id);

    try {
      await dispatch(DeleteAppSetup(allIds)).unwrap();

      setSelectedRows([]);
      setSelectAll(false);
      setDeleteType(null);
      setRDelete(false);

      await fetchNotifications(1);
    } catch (error) {
      console.error("Delete all notifications error:", error);
    }
  };

  const renderPagination = () => {
    if (total <= perPage) {
      return null;
    }

    const lastPage = Math.ceil(total / perPage);

    return (
      <div className="d-flex justify-content-end mt-3">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />

          {Array.from({ length: lastPage }, (_, index) => {
            const page = index + 1;

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            disabled={currentPage === lastPage}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  const showingFrom = total === 0 ? 0 : (currentPage - 1) * perPage + 1;

  const showingTo = Math.min(currentPage * perPage, total);

  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);

  const [sendLoadingId, setSendLoadingId] = useState(null);

  return (
    <section className="Notification common_section">
      {/* <div className="common_btn_div">
        <button
          type="button"
          className="orange_btn"
          onClick={() => navigate("/student/notification/create")}
        >
          Create Notification
        </button>
      </div> */}
      <div className="sectin_top">
        <h2 className="section_name">App Setup</h2>
      </div>
      {/* <div className="delete_btn_div">
        <button
          type="button"
          className="delete_selected"
          onClick={handleDeleteSelectedClick}
          disabled={selectedRows.length === 0}
        >
          <FontAwesomeIcon icon={faTrash} /> Delete Selected
        </button>

        <button
          type="button"
          className="delete_all"
          onClick={handleDeleteAllClick}
          disabled={rows.length === 0}
        >
          <FontAwesomeIcon icon={faTrash} /> Delete All
        </button>
      </div> */}
      <div className="table-responsive custom-table-wrapper mt-2">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              {/* <th className="checkbox_column">
                <Form.Check
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="table_checkbox"
                  disabled={rows.length === 0}
                />
              </th> */}

              <th>Sr. No</th>
              <th>Email</th>
              <th>Contact no</th>
              <th>App ID</th>
              {/* <th>App Sign</th>
              <th>Server Secret</th>
              <th>Call Back Secret</th> */}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <tr
                  key={row.id}
                  className={index % 2 === 0 ? "row-even" : "row-odd"}
                >
                  {/* <td className="checkbox_column">
                    <Form.Check
                      type="checkbox"
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleRowSelect(row.id)}
                      className="table_checkbox"
                    />
                  </td> */}

                  <td className="fw-bold">
                    {(currentPage - 1) * perPage + index + 1}
                  </td>

                  <td className="fw-bold">{row?.email || "-"}</td>

                  <td className="fw-bold">{row?.contact_no || "-"}</td>
                  <td className="fw-bold">{row?.AppID || "-"}</td>
                  {/* <td className="fw-bold">{row?.AppSign || "-"}</td>
                <td className="fw-bold">{row?.ServerSecret || "-"}</td>
                  <td className="fw-bold">{row?.CallbackSecret || "-"}</td> */}

                  <td>
                    <Button variant="link" className="p-0 action-btn">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="icon-edit"
                        onClick={() => navigate(`/student/app-setup/${row.id}`)}
                      />
                    </Button>
                    {/* <Button
                      variant="link"
                      className="p-0 action-btn"
                      onClick={() => handleDeleteClick(row)}
                      title="Delete"
                    >
                      <FontAwesomeIcon icon={faTrash} className="icon-delete" />
                    </Button> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="result_div">
        <p className="inner_text">
          Showing {showingFrom} to {showingTo} of {total}
        </p>
      </div>
      {renderPagination()}
      {rdelete && (
        <CDeleteModel
          show={rdelete}
          setShow={setRDelete}
          action={
            deleteType === "multiple"
              ? handleDeleteSelected
              : deleteType === "all"
              ? handleDeleteAll
              : handleDelete
          }
          text={
            deleteType === "multiple"
              ? `Are you sure you want to delete ${
                  selectedRows.length
                } selected notification${selectedRows.length > 1 ? "s" : ""}?`
              : deleteType === "all"
              ? `Are you sure you want to delete all ${rows.length} notifications on this page?`
              : "Are you sure you want to delete this notification?"
          }
        />
      )}

      <Success_Modal
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
          navigate(-1);
        }}
      />

      <Reject_Modal
        show={showReject}
        onHide={() => {
          setShowReject(false);
          navigate(-1);
        }}
      />
    </section>
  );
};

export default Notification;
